import { render, staticRenderFns } from "./CmsEditions.vue?vue&type=template&id=6653eca5&"
import script from "./CmsEditions.vue?vue&type=script&lang=js&"
export * from "./CmsEditions.vue?vue&type=script&lang=js&"
import style0 from "./CmsEditions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports